// extracted by mini-css-extract-plugin
var _1 = "container--bI5ee";
var _2 = "content--N3uYr";
var _3 = "deleteButton--E6IZn";
var _4 = "editActions--ye2PK";
var _5 = "editButton--BnaBD";
var _6 = "error--GzbIX";
var _7 = "header--COOon";
var _8 = "placeholder--omxgS";
var _9 = "placeholderIcon--l0qiP";
var _a = "placeholderText--j6j5m";
var _b = "title--MqZqL";
export { _1 as "container", _2 as "content", _3 as "deleteButton", _4 as "editActions", _5 as "editButton", _6 as "error", _7 as "header", _8 as "placeholder", _9 as "placeholderIcon", _a as "placeholderText", _b as "title" }
